import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/common/Navbar';
import Hero from './components/common/Hero';
import WhatWeDo from './components/home/WhatWeDo';
import VisionSection from './components/pages/about/VisionSection';
import AboutBanner from './components/pages/about/AboutBanner';
import VideoSection from './components/home/VideoSection';
import CategoriesSection from './components/CategoriesSection';
import ComicBooks from './components/ComicBooks';
import ComicHeroes from './components/ComicHeroes';
import LatestBlog from './components/LatestBlog';
import Footer from './components/common/Footer';
import ContactInfoSection from './components/pages/contact/ContactInfoSection';
import QuickContact from './components/pages/contact/QuickContact';
import BlogSection from './components/pages/blog/BlogSection';
import ShopSection from './components/pages/shop/ShopSection';
import QuestionsAnswers from './components/QuestionsAnswers';
import Testimonial from './components/Testimonial';
import PurposeSection from './components/PurposeSection';
import CartPage from './components/pages/cart/CartPage';
import CheckoutPage from './components/pages/checkout/CheckoutPage';
import ProductPage from './components/pages/product/ProductPage';

import { useTranslation } from 'react-i18next';

function App() {
  const { t, i18n } = useTranslation('common');
  const lng = (i18n.language || 'en').split('-')[0];
  const pageMap = {
    about: { ar: 'من نحن', ur: 'ہمارے بارے میں', en: 'About', fr: 'À propos', de: 'Über uns', es: 'Acerca de', pt: 'Sobre', ja: '私たちについて', hi: 'हमारे बारे में', it: 'Chi siamo', ru: 'О нас', zh: '关于我们' },
    shop: { ar: 'المتجر', ur: 'دکان', en: 'Shop', fr: 'Boutique', de: 'Shop', es: 'Tienda', pt: 'Loja', ja: 'ショップ', hi: 'दुकान', it: 'Negozio', ru: 'Магазин', zh: '商店' },
    blog: { ar: 'المدونة', ur: 'بلاگ', en: 'Blog', fr: 'Blog', de: 'Blog', es: 'Blog', pt: 'Blog', ja: 'ブログ', hi: 'ब्लॉग', it: 'Blog', ru: 'Блог', zh: '博客' },
    contact: { ar: 'اتصل بنا', ur: 'رابطہ', en: 'Contact', fr: 'Contact', de: 'Kontakt', es: 'Contacto', pt: 'Contato', ja: 'お問い合わせ', hi: 'संपर्क', it: 'Contatti', ru: 'Контакты', zh: '联系' }
  };
  const tv = (key, fallback) => i18n.getResource(lng, 'common', key) || fallback;
  const aboutTitle = tv('pages.about', pageMap.about[lng]);
  const blogTitle = tv('pages.blog', pageMap.blog[lng]);
  const contactTitle = tv('pages.contact', pageMap.contact[lng]);
  const shopTitle = tv('pages.shop', pageMap.shop[lng]);
  function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);
    return null;
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={(
            <>
              <Hero />
              <WhatWeDo />
              <VideoSection />
              <ComicBooks />
              <CategoriesSection />
              <ComicHeroes />
              <LatestBlog />
            </>
          )}
        />

        {/* About */}
        <Route
          path="/about"
          element={(
            <>
              <Hero
                title={aboutTitle}
                backgroundImage="/assets/imgs/About/Inner%20Pages_Picture_About_Banner.png"
                showSocial={false}
                showPlay={false}
                heightClasses="h-[40vh] md:h-[50vh] lg:h-[60vh]"
              />
              <VisionSection />
              <AboutBanner />
              <PurposeSection />
              <Testimonial />
              <ComicHeroes />
              <QuestionsAnswers />
            </>
          )}
        />

        {/* Blog */}
        <Route
          path="/blog"
          element={(
            <>
              <Hero
                title={blogTitle}
                backgroundImage="/assets/imgs/Blogs/Inner Pages_Picture_Blog_3.png"
                showSocial={false}
                showPlay={false}
                heightClasses="h-[40vh] md:h-[50vh] lg:h-[60vh]"
                bgSize="cover"
                bgPosition="center top"
              />
              <BlogSection />
            </>
          )}
        />

        {/* Contact */}
        <Route
          path="/contact"
          element={(
            <>
              <Hero
                title={contactTitle}
                backgroundImage="/assets/imgs/Contact/Inner Pages_Picture_Contact_Banner.png"
                showSocial={false}
                showPlay={false}
                heightClasses="h-[40vh] md:h-[50vh] lg:h-[60vh]"
              />
              <ContactInfoSection />
              <QuickContact />
            </>
          )}
        />

        {/* Shop */}
        <Route
          path="/shop"
          element={(
            <>
              <Hero
                title={shopTitle}
                backgroundImage="/assets/imgs/Shop/Inner Pages_Picture_Shop_Banner.png"
                showSocial={false}
                showPlay={false}
                heightClasses="h-[40vh] md:h-[50vh] lg:h-[60vh]"
              />
              <ShopSection />
            </>
          )}
        />

        {/* Product */}
        <Route path="/product" element={<ProductPage />} />

        {/* Cart */}
        <Route path="/cart" element={<CartPage />} />

        {/* Checkout */}
        <Route path="/checkout" element={<CheckoutPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
